//TODO: REFACTOR THIS GUY TO ANOTHER NAME, IS NOT ONLY FOR USER DISPLAY ANYMORE

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
	Avatar,
	Badge,
	DisplayIcon,
	Icon,
	LinkButton,
	Text,
	Tooltip,
} from '@nicheinc/campus-ds';

import { TableMapperType } from '../../types';

type PropsType = {
	mapperField: TableMapperType;
	item: any;
};

const Wrapper = styled.div<{ onClick?: any }>`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spacing.medium};
	cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

	.texts-wrapper {
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacing.xxs};

		.title-wrapper {
			position: relative;
		}
	}
`;
const ThumbnailBadgeWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${({ theme }) => theme.shapeRadius.xxs};
	position: relative;
`;
const ThumbnailWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	overflow: hidden;
	border-radius: ${({ theme }) => theme.shapeRadius.xxs};
	img {
		width: 100%;
	}
`;
const OverlayWrapper = styled.div`
	position: absolute;
	bottom: -6px;
	right: -6px;
	width: 22px;
	height: 22px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${({ theme }) => theme.shapeRadius.xxs};
`;

const LineClampedLinkButton = styled(LinkButton)<{ $lineClamp?: number }>`
	${({ $lineClamp }) =>
		$lineClamp &&
		`
    display: -webkit-box;
    -webkit-line-clamp: ${$lineClamp};
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    word-break: break-word;
  `}
`;

function UserDisplayCell({ mapperField, item }: PropsType) {
	const textMaxLength = mapperField?.textMaxLength;

	const titleText = item[mapperField?.userTitleKey || 'name'];
	const subTitleText = item[mapperField?.userSubTitleKey || 'email'];

	const badgeText =
		typeof mapperField.userBadge === 'function'
			? mapperField.userBadge(item)
			: mapperField.userBadge;
	const userIconName =
		typeof mapperField.userIcon === 'function'
			? mapperField.userIcon(item)
			: mapperField.userIcon;

	const userSubTitleIconName =
		typeof mapperField.userSubTitleIconName === 'function'
			? mapperField.userSubTitleIconName(item)
			: mapperField.userSubTitleIconName;

	const userSubTitleIconColor =
		typeof mapperField.userSubTitleIconColor === 'function'
			? mapperField.userSubTitleIconColor(item)
			: mapperField.userSubTitleIconColor;

	const userIconTooltipText =
		typeof mapperField.userIconTooltipText === 'function'
			? mapperField.userIconTooltipText(item)
			: mapperField.userIconTooltipText;

	const isDisabled =
		typeof mapperField.isDisabled === 'function'
			? mapperField.isDisabled(item)
			: mapperField.isDisabled;

	const userDisplayIconProps =
		typeof mapperField?.userDisplayIconProps === 'function'
			? mapperField?.userDisplayIconProps(item)
			: mapperField?.userDisplayIconProps;

	const userThumbnailBadgeIconProps =
		typeof mapperField?.userThumbnailBadgeIconProps === 'function'
			? mapperField?.userThumbnailBadgeIconProps(item)
			: mapperField?.userThumbnailBadgeIconProps;

	const useThumbnail =
		typeof mapperField?.useUserThumbnail === 'function'
			? mapperField?.useUserThumbnail(item)
			: !!mapperField?.useUserThumbnail;

	const titleFontWeight =
		typeof mapperField?.userTitleFontWeight === 'function'
			? mapperField?.userTitleFontWeight(item)
			: mapperField?.userTitleFontWeight || 'medium';

	const subTitleFontWeight =
		typeof mapperField?.userSubTitleFontWeight === 'function'
			? mapperField?.userSubTitleFontWeight(item)
			: mapperField?.userSubTitleFontWeight || 'regular';

	const userTitleItalic =
		typeof mapperField?.userTitleItalic === 'function'
			? mapperField?.userTitleItalic(item)
			: mapperField?.userTitleItalic || false;

	const userSubTitleItalic =
		typeof mapperField?.userSubTitleItalic === 'function'
			? mapperField?.userSubTitleItalic(item)
			: mapperField?.userSubTitleItalic || false;

	const titleLineClamp =
		typeof mapperField?.userTitleLineClamp === 'function'
			? mapperField?.userTitleLineClamp(item)
			: mapperField?.userTitleLineClamp || 1;

	const subTitleLineClamp =
		typeof mapperField?.userSubTitleLineClamp === 'function'
			? mapperField?.userSubTitleLineClamp(item)
			: mapperField?.userSubTitleLineClamp || 1;

	//Text truncation
	const titleRef = useRef<HTMLDivElement | HTMLAnchorElement>(null);
	const subTitleRef = useRef<HTMLDivElement>(null);

	const [isTitleTruncated, setIsTitleTruncated] = useState(false);
	const [isSubTitleTruncated, setIsSubTitleTruncated] = useState(false);

	const truncateText = (text: string) => {
		if (textMaxLength && text && text.length > textMaxLength) {
			return `${text.substring(0, textMaxLength).trim()}...`;
		}
		return text;
	};

	const getTooltipText = () => {
		if (!isTitleTruncated && !isSubTitleTruncated) {
			return '';
		}

		if (isTitleTruncated && isSubTitleTruncated) {
			return `${titleText}\n${subTitleText}`;
		}

		if (isTitleTruncated) {
			return titleText;
		}

		if (isSubTitleTruncated) {
			return subTitleText;
		}
	};

	useEffect(() => {
		// Check if text is truncated by maxLength config
		if (titleText && textMaxLength && titleText.length > textMaxLength) {
			setIsTitleTruncated(true);
		}

		if (subTitleText && textMaxLength && subTitleText.length > textMaxLength) {
			setIsSubTitleTruncated(true);
		}

		const titleElement = titleRef.current;
		const subTitleElement = subTitleRef.current;

		const checkTruncation = () => {
			// Only check if we haven't already determined it's truncated
			if (!isTitleTruncated && titleElement) {
				const isTitleElementTruncated =
					titleElement.scrollHeight > titleElement.clientHeight + 1;
				if (isTitleElementTruncated) {
					setIsTitleTruncated(true);
				}
			}

			if (!isSubTitleTruncated && subTitleElement) {
				const isSubTitleElementTruncated =
					subTitleElement.scrollHeight > subTitleElement.clientHeight + 1;
				if (isSubTitleElementTruncated) {
					setIsSubTitleTruncated(true);
				}
			}
		};

		if (titleElement || subTitleElement) {
			// Use requestAnimationFrame to ensure elements are rendered
			requestAnimationFrame(checkTruncation);
		}

		const resizeObserver = new ResizeObserver(() => {
			requestAnimationFrame(checkTruncation);
		});

		if (titleElement) resizeObserver.observe(titleElement);
		if (subTitleElement) resizeObserver.observe(subTitleElement);

		return () => {
			resizeObserver.disconnect();
		};
	}, [
		titleText,
		subTitleText,
		textMaxLength,
		isTitleTruncated,
		isSubTitleTruncated,
	]);

	return (
		<>
			<Wrapper
				onClick={
					mapperField?.onUserClick
						? () => mapperField?.onUserClick && mapperField?.onUserClick(item)
						: undefined
				}
			>
				{useThumbnail &&
					!userDisplayIconProps &&
					!userThumbnailBadgeIconProps && (
						<ThumbnailWrapper>
							<img
								src={item[mapperField?.userPictureKey || 'profilePicture']}
								alt={item.name}
							/>
						</ThumbnailWrapper>
					)}
				{useThumbnail &&
					!userDisplayIconProps &&
					userThumbnailBadgeIconProps && (
						<ThumbnailBadgeWrapper>
							<ThumbnailWrapper>
								<img
									src={item[mapperField?.userPictureKey || 'profilePicture']}
									alt={item.name}
								/>
							</ThumbnailWrapper>
							<OverlayWrapper>
								<DisplayIcon {...userThumbnailBadgeIconProps} />
							</OverlayWrapper>
						</ThumbnailBadgeWrapper>
					)}

				{!useThumbnail && !userDisplayIconProps && (
					<Avatar image={item.profilePicture} name={item.name} />
				)}

				{userDisplayIconProps && !useThumbnail && (
					<DisplayIcon {...userDisplayIconProps} />
				)}

				<Tooltip content={getTooltipText()}>
					<div className="texts-wrapper">
						<div className="title-wrapper">
							{(!!mapperField?.onUserTitleClick ||
								!!mapperField?.getUserTitleLinkHref) && (
								<LineClampedLinkButton
									$lineClamp={titleLineClamp}
									onClick={() =>
										mapperField?.onUserTitleClick &&
										mapperField?.onUserTitleClick(item)
									}
									href={
										mapperField?.getUserTitleLinkHref &&
										mapperField?.getUserTitleLinkHref(item)
									}
									weight="regular"
									lineHeight="medium"
									ref={titleRef as React.Ref<HTMLAnchorElement>}
								>
									{titleLineClamp && !textMaxLength
										? titleText
										: textMaxLength
											? truncateText(titleText)
											: titleText}
								</LineClampedLinkButton>
							)}
							{!mapperField?.onUserTitleClick &&
								!mapperField?.getUserTitleLinkHref && (
									<Text
										lineHeight="medium"
										lineClamp={titleLineClamp}
										size="small"
										fontWeight={titleFontWeight}
										color={
											isDisabled ? 'system.text.medium' : 'system.text.default'
										}
										isItalic={userTitleItalic}
										ref={titleRef}
										preserveWhiteSpace
									>
										{titleLineClamp && !textMaxLength
											? titleText
											: textMaxLength
												? truncateText(titleText)
												: titleText}
									</Text>
								)}
						</div>
						<div className="title-wrapper d-flex align-items-center gap-1">
							{mapperField.userSubTitleIconName && !!userSubTitleIconName && (
								<Icon
									iconName={userSubTitleIconName as string}
									color={
										userSubTitleIconColor && userSubTitleIconColor
											? userSubTitleIconColor
											: 'system.text.weak'
									}
									weight="fill"
									size="xs"
								/>
							)}
							<Text
								lineClamp={subTitleLineClamp}
								size="small"
								color="system.text.medium"
								fontWeight={subTitleFontWeight}
								isItalic={userSubTitleItalic}
								lineHeight="large"
								ref={subTitleRef}
								preserveWhiteSpace
							>
								{subTitleLineClamp && !textMaxLength
									? subTitleText
									: textMaxLength
										? truncateText(subTitleText)
										: subTitleText}
							</Text>
						</div>
					</div>
				</Tooltip>

				{mapperField?.userBadge && !!badgeText && (
					<Badge text={badgeText} size="small" variant="warning" />
				)}

				{mapperField?.userIcon && !!userIconName && (
					<Tooltip content={userIconTooltipText || ''}>
						<span>
							<Icon
								iconName={userIconName}
								color="system.text.weak"
								weight="fill"
							/>
						</span>
					</Tooltip>
				)}
			</Wrapper>
		</>
	);
}

export default React.memo(UserDisplayCell);
